import { create } from "zustand";
import { persist } from "zustand/middleware";
import { toast } from "react-hot-toast";
import { axiosInstancev1 } from "../../lib/axiosInstance";
import useAuthStore from "../useAuthStore";

const useProfileStore = create(
  persist(
    (set, get) => ({
      profile: null,
      isLoading: false,

      // ✅ Fetch Profile Data
      fetchProfile: async () => {
        set({ isLoading: true });

        const { userType, token, user } = useAuthStore.getState();

        if (userType !== "builder" || !token || !user || !user.id) {
          toast.error("Unauthorized: Builder login required or builder ID missing.");
          set({ isLoading: false });
          return;
        }

        try {
          const response = await axiosInstancev1.get(
            `/user-info/builder/${user.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          set({ profile: response.data });
        } catch (error) {
          console.error("Profile Fetch Error:", error);
          toast.error(error.response?.data?.message || "Failed to load profile");
        } finally {
          set({ isLoading: false });
        }
      },

      // ✅ Update Profile Data
      updateProfile: async (profileData) => {
        set({ isLoading: true });

        const { userType, token, user } = useAuthStore.getState();

        if (userType !== "builder" || !token || !user || !user.id) {
          toast.error("Unauthorized: Builder login required or builder ID missing.");
          set({ isLoading: false });
          return;
        }

        try {
          const response = await axiosInstancev1.put(
            `/user-info/builder/${user.id}`,
            profileData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
              },
            }
          );

          set({ profile: response.data });
          toast.success("Profile updated successfully");
        } catch (error) {
          console.error("Profile Update Error:", error);
          toast.error(error.response?.data?.message || "Failed to update profile");
        } finally {
          set({ isLoading: false });
        }
      },
    }),
    {
      name: "profile-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useProfileStore;